module.exports = __webpack_public_path__ + "media/images/site/laliga-3fb0197492481a08af8085124a79a882.svg";